window.wxappid = "wx38fd8f815b62199a";
window.wxpayappid = "wx947a0dfd0fd02d5b";
window.wxartcilappid = "wx95ba7ccbc20866d3";
export default {
  install(Vue) {
    /**
     * @description: url去重
     * @return {*}
     */    
    Vue.prototype.removeDuplicateKeys = function(url){
      const _this=this;
      let nurl = url;
      if(url.indexOf('?')>-1){
        nurl= url.split('?')[0]+'?'+_this.paramtourl(_this.urltourlparam(url))
      }
      return nurl;
    },
    /**
     * @description: 替换url中指定参数值
     * @return {*}
     */    
    Vue.prototype.replaceUrlParams = function(url,key, value){
      let nurl = url;
      if(url.indexOf(key)>-1){
        nurl = url.replace(new RegExp(key + "=([^&]*)", "g"), key + "=" + value);
      }else{
        nurl =url + (url.indexOf('?')>-1?'&':'?') + key + "=" + value; 
      }
      return nurl
    },
    /**
     * @description: 获取ab测试结果
     * @return {*}
     */
    Vue.prototype.getAbTest = function (parsms) {
      const _this = this;
      if(location.href.indexOf('abTest=')>-1){
        parsms.callback(_this.getUrlParam('abTest'))
      }else{
        _this.sensorsCustom.abTest().then((hxSensorsABTestCase) => {
          // 获取实验结果
          hxSensorsABTestCase?.fastFetchABTest(parsms);
        });
      }
    };
    /**
     * @description: 提交神策买点
     * @return {*}
     */
    Vue.prototype._sendTrack = function(name, params) {
      const _this=this;
      if (_this.sensorsCustom && _this.sensorsCustom.sendTrack) {
        _this.sensorsCustom.sendTrack(name, params);
      }
    }
    // 继承sensorsCustom
    Vue.prototype.sensorsCustom = window.sensorsCustom;
    // 继承httpToHttps
    Vue.prototype.httpToHttps = window.httpToHttps;
    /**
     * @description: 获取置顶cookie
     * @param {*} name
     * @return {*}
     */
    Vue.prototype.getCookie = function (name) {
      var cookies = document.cookie.split("; ");
      for (var item of cookies) {
        var parts = item.split("=");
        if (parts[0] === name) {
          return item.split(`${name}=`)[1];
        }
      }
      return null;
    };
    /**
     * 动态引入js文件
     * @method loadJS
     * @param {string} url js地址
     *  @param {string} callback 回调函数
     * @return {string} 无返回值
     */
    Vue.prototype.loadJS = function (url, callback) {
      const script = document.createElement("script"),
        fn = callback || function () {};
      script.type = "text/javascript";
      //IE
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (
            script.readyState === "loaded" ||
            script.readyState === "complete"
          ) {
            script.onreadystatechange = null;
            fn();
          }
        };
      } else {
        //其他浏览器
        script.onload = function () {
          fn();
        };
      }
      script.src = url;
      document.getElementsByTagName("body")[0].appendChild(script);
    };
    /**
     * 判断是pc还是h5
     * @method ispc
     * @param {string} ispc
     * @return {string} 返回是否是pc
     */
    (Vue.prototype.ispc = function () {
      const userAgentInfo = navigator.userAgent;
      const Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      let flag = true;
      for (let item of Agents) {
        if (userAgentInfo.indexOf(item) > -1) {
          flag = false;
          break;
        }
      }
      return flag;
    }),
      /**
       * @description: 获取字符串中参数
       * @param {*} regexp 参数名称
       * @param {*} str 字符串
       * @return {*}
       */

      (Vue.prototype.getStrParam = function (regexp, str) {
        //构造一个含有目标参数的正则表达式对象
        var reg = new RegExp("(^|&)" + regexp + "=([^&]*)(&|$)");
        //匹配目标参数
        var r =
          str.indexOf("?") > -1
            ? str.toLowerCase().split("?")[1].match(reg)
            : null;
        //返回参数值
        if (r != null) return unescape(r[2]);
        return null;
      });
    /**
     * 获取url参数
     * @method getUrlParam
     * @param {string} sting 要获取的字符串
     * @return {string} 返回处理后的结果
     */
    Vue.prototype.getUrlParam = function (string) {
      //构造一个含有目标参数的正则表达式对象
      const reg = new RegExp(`(^|&)${string}=([^&]*)(&|$)`);
      //匹配目标参数
      const r = window.location.search.substr(1).match(reg);
      //返回参数值
      let result = null;
      if (r !== null) {
        result = unescape(r[2]);
      }
      return result;
    };
    /**
     * Promise同步读取数据接口
     * @method getResolve
     * @param {string} apiname 接口名称
     * @param {string} param 接口名称
     * @return {string} 返回处理后的结果
     */
    Vue.prototype.getResolve = function (apiname, param) {
      param = typeof param == "undefined" ? {} : param;
      const _this = this;
      return new Promise((resolve) =>
        _this.getData(
          _this.apilist(apiname),
          function (a) {
            resolve(a);
          },
          param
        )
      );
    };
    /**
     * json派生url
     * @method param
     * @param {string} data 要转换的数组
     * @return {string} url 返回处理后的结果
     */
    Vue.prototype.paramtourl = function (data) {
      let url = "",
        value;
      const _keyArr = Object.keys(data);
      _keyArr.forEach(function (k) {
        value = data[k] !== undefined ? data[k] : "";
        url += `&${k}=${encodeURIComponent(value)}`;
      });
      // 删除第一个&
      return url ? url.substring(1) : "";
    };
    /**
     * url派生json
     * @method param
     * @param {string} data 要转换的url
     * @return {string} url 返回处理后的结果
     */
    Vue.prototype.urltourlparam = function (data) {
      let sourceURL = data.indexOf("?") > -1 ? data.split("?")[1] : data;
      return sourceURL
        .split("&")
        .map((p) => p.split("="))
        .reduce((obj, pair) => {
          const [key, value] = pair.map(decodeURIComponent);
          return { ...obj, [key]: value };
        }, {});
    };
    /**
     * URL参数去重（保留大小写）
     * @method removeDuplicateParamsCaseSensitive
     * @param {string} url 要处理的URL
     * @return {string} 返回去重后的URL
     */
    Vue.prototype.removeDuplicateParamsCaseSensitive = function (url) {
      if (!url) return url;

      // 分割url和参数
      const [baseUrl, queryString] = url.split("?");
      if (!queryString) return url;

      // 将参数字符串转换为数组，保持原始顺序
      const paramsArray = queryString.split("&");

      // 使用Map来存储参数，保留最后一个出现的值
      const paramsMap = new Map();
      paramsArray.forEach((param) => {
        const [key, value] = param.split("=");
        paramsMap.set(key, value);
      });

      // 将Map转回参数字符串
      const newQueryString = Array.from(paramsMap.entries())
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

      // 返回处理后的完整url
      return `${baseUrl}?${newQueryString}`;
    };
    /**
     * jsonp请求
     * @method getResolve
     * @param {string} url 接口地址
     * @param {function} fn 回调函数
     * @param {Array} data 参数
     * @return {string} 返回处理后的结果
     */
    Vue.prototype.getData = function (url, fn, data, timeout) {
      data = typeof data == "undefined" ? {} : data;
      let _url =
        typeof httpToHttps !== "undefined" && httpToHttps.editHost
          ? httpToHttps.editHost(url)
          : url;
      _url = window.location.href.indexOf("pro=") > -1 ? url : _url;
      // if (data) {
      //     _url += (_url.indexOf('?') < 0 ? '?' : '&') + this.paramtourl(data);
      // }
      $.ajax({
        url: _url,
        type: "GET",
        dataType: "jsonp",
        jsonp: "callback",
        xhrFields: {
          withCredentials: true,
        },
        timeout: timeout ? timeout : 10000,
        data,
        success: function (data) {
          fn && fn(data);
        },
        error: function (err) {
          if (
            typeof err == "object" &&
            err.toString().indexOf("Timeout") > -1
          ) {
            console.log(url + "接口超时");
          }
          fn && fn(err);
        },
      });
      // Jsonp(_url, { param: null, name: `jsonpcallback${new Date().getTime() + Math.ceil(Math.random() * 10000)}`,timeout:timeout?timeout:10000}, (err, response) => {
      //     if (err) {
      //          //console.error('err=', err.message);
      //          if(typeof err == 'object'&& err.toString().indexOf ('Timeout') > -1){
      //             console.log(url+'接口超时')
      //           }
      //          fn && fn(err)
      //     } else {
      //         fn && fn(response)
      //     }
      // })
    };
    /**
     * @description: extend 遍历继承
     * @param {*}
     * @return {*}
     */
    Vue.prototype.extend = function (destination, source) {
      if (typeof destination == "object") {
        //destination是一个json对象
        if (typeof source == "object") {
          //source是一个json对象
          //把source中的每一个key,value值赋值给destination
          for (var i in source) {
            destination[i] = source[i];
          }
        }
      }

      if (typeof destination == "function") {
        if (typeof source == "object") {
          for (var b in source) {
            destination.prototype[b] = source[b];
          }
        }
        if (typeof source == "function") {
          destination.prototype = source.prototype;
        }
      }
      return destination;
    };
    /**
     * 是否是测试
     * @method isTest
     * @param {string} text 类型
     * @return {string} 返回相关字符串
     */
    Vue.prototype.isTest = function (text) {
      const istest =
        window.location.href.indexOf("pro=") < 0 &&
        window.location.host.indexOf("test") > -1
          ? true
          : false;
      const testlist = {
        undefined: istest,
        test: istest ? "test" : "",
        "test-": istest ? "test-" : "",
        "test.": istest ? "test." : "",
      };
      if (typeof testlist[text] === "undefined") {
        return istest;
      } else if (typeof testlist[text] === "function") {
        return testlist[text]();
      } else {
        return testlist[text];
      }
    };
    /**
     * 接口集合
     * @method apilist
     * @param {string} name 接口名字
     * @return {string} 返回相关字符串
     */
    Vue.prototype.apilist = function (name) {
      const domain = `https://${this.isTest("test")}gw.homeway.com.cn/`;
      const adapidomain = this.isTest()
        ? "https://adapi-test.homeway.com.cn/"
        : "https://adapi.homeway.com.cn/";
      const regdomain = `https://${this.isTest("test")}regtool.homeway.com.cn/`;
      let buydomain = `https://${this.isTest("test-")}buy.homeway.com.cn/`;
      const caidaohost = `https://${
        this.isTest() ? "testcaidao" : "imgcd"
      }.homeway.com.cn/`;
      let callviphomst = `https://${this.isTest(
        "test-"
      )}callvip.homeway.com.cn/`;
      let callviiscrm = `https://${this.isTest(
        "test-"
      )}callvip.homeway.com.cn/`;
      let fastpaydomain = this.isTest()
        ? "https://buy-test.intcoop.homeway.com.cn/"
        : `https://buy.homeway.com.cn/`;
      // 正式环境 caidaoad.homeway.com.cn 和 caidaoad.hexun.com
      //测试环境 testcaidaoad.homeway.com.cn 和 caidaoad-test.intcoop.hexun.com
      if (location.host.indexOf("hexun.com") > -1) {
        buydomain = `https://${this.isTest("test-")}buy.hexun.com/`;
        callviphomst = `https://${this.isTest("test-")}callvip.hexun.com/`;
        callviiscrm = `https://${this.isTest("test-")}scrm.hexun.com/`;
      }
      const api = {
        undefined: "",
        //登录信息
        isLogin: `https://${this.isTest(
          "test"
        )}regtool.homeway.com.cn/check/state`,
        //验证手机号
        isBinPhone: "https://regtool.homeway.com.cn/bind/mobileState",
        // 获取所属机构
        getorganizations: `${adapidomain}api/cooperator/management/get_organizations`,
        // 获取客服链接
        serviceurl: `${callviiscrm}scrm-api/externalApi/getCustomersServiceUrl`,
        // 获取短连接
        sorturl: `${domain}shorturl/api/create-url`,
        // 易盾开关
        edunstate: `${domain}regtool/api/v1/business/edunstate`,
        // 获取图形验证码
        imgcode: `${domain}regtool/api/v1/imageVerifyCode/getCode`,
        // 发送验证码
        sendcode: `${domain}regtool/api/v1/mobile/send`,
        // 手机注册登陆
        phonelogin: `${domain}regtool/api/v1/user/loginByCode`,
        // 公共头
        headh5: `${caidaohost}commonhead/${
          this.isTest() ? "" : "v4.0/"
        }h5/js/commonhead.js`,
        // 获取usreid和code
        getuserid: `${regdomain}api/v1/bindOtherWebAccount/getCode`,
        upimg: `${domain}photo/Upload/UploadPhoto.aspx?encode=utf-8&type=4&extName=`,
        save: `${adapidomain}api/market/save_market_page`,
        getmarketpagebyid: `${adapidomain}api/market/get_market_page_by_id`,
        // 最新版本唤起小程序接口，其他的没有缓存请慎用
        getminiurllink: `${domain}weixin/miniapp/scrm/url-link/${window.wxappid}/home`,
        getschema: `${domain}weixin/miniapp/${window.wxappid}/urlscheme-generate`,
        getpayschema: `${domain}weixin/miniapp/${window.wxpayappid}/urlscheme-generate`,
        getartcilschema: `${domain}weixin/miniapp/${window.wxartcilappid}/urlscheme-generate`,
        postgdt: `${callviiscrm}scrm-api/externalApi/uploadUserAction`,
        getmodelist: `${adapidomain}api/theme/query_theme_list_by_ids`,
        getappid: `${domain}weixin/miniapp/config/get`,
        // 搜索股票
        getstock: `https://so.hexun.com/ajax.do?type=STOCK&stype=STOCK`,
        getstockdetai: `https://stocksquote.hexun.com/a/quotelist`,
        // 快捷支付
        fastpay: `${fastpaydomain}order-site/pay/quickpay`,
        // 根据invoketoken获取订单状态
        fastpaygetinvoketoken: `${buydomain}order-rest/pay/get-invoketoken-order-payed`,
        // 根据订单号获取订单状态
        fastgetpaystatus: `${buydomain}order-site/wallet/getpaystatus`,
        // 获取单品信息
        getproductinfo: `${callviphomst}jsapi/product/get-product-info`,
        // 获取套餐信息
        getpackageinfo: `${callviphomst}jsapi/product/get-package-info`,
        // 0元直接下单
        freeorderopenright: `${callviphomst}jsapi/order/freeorder-openright`,
        // 查询用户的订单数量
        getuserordercount: `${buydomain}order-rest/query/get-user-order-count`,
        // 上报utm_campaign参数
        uploadZbUserAction: `${callviiscrm}scrm-api/externalApi/uploadZbUserAction`,
        // 微吼视频地址
        videosrc:
          "https://hexun.vhall.homeway.com.cn/v3/lives/embedclientfull/watch/",
        // 报名组件信息提交
        weActivitySignUp: `${callviiscrm}scrm-api/wecom/weActivitySignUp/in`,
        // 获取unito
        //getwxunionid:`https://${this.isTest() ? 'test' : ''}regapi.homeway.com.cn/wx/user-info?gourl=`,
        getwxunionid: `https://regapi.homeway.com.cn/wx/user-info?gourl=`,
        // 获取二维码组件是否已经加企微
        getServiceCustomerStatus: `${callviiscrm}scrm-api/externalApi/getServiceCustomerStatus`,
        // 客户进入到落地页,如果已经授权或者授权了,就调这个接口把unionid和落地页url编码后传到接口,可异步,只为为了记录浏览记录
        uploadUserActionRecord: `${callviiscrm}scrm-api/externalApi/uploadUserActionRecord`,
        // 获取实验分组数据
        gettestgroup: `https://apptrace.hexun.com/testgroup/group`,
        // 获取获客助手地址
        getAcquisitionRedirectionUrl: `${callviphomst}scrm-api/externalApi/getAcquisitionRedirectionUrl`,
        // 上报用户参数
        uploadPageUserAction: `${callviiscrm}scrm-api/externalApi/uploadPageUserAction`,
        // 根据组ID获取二维码
        getQrCode: `${callviiscrm}scrm-api/wecom/allocationCorpUser/showQRCode`,
        // 获取快捷支付订单支付状态
        getInvoketokenOrderPayed: `${buydomain}order-rest/pay/get-invoketoken-order-payed`,
        // 获取企微活码地址
        getWeUserCodePoolRedirectionUrl:`${callviiscrm}scrm-api/externalApi/getWeUserCodePoolRedirectionUrl`,
        // 快捷支付继续支付
        setQuickContinuePay: `${fastpaydomain}order-site/pay/quick-continue-pay`,
        // 订单支付继续支付
        setContinuepay: `${fastpaydomain}order-site/pay/continuepay`,
      };
      return api[name];
    };
  },
};
